import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { NounSubtypeKey, TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { ZeplinIcon, ZeplinIconBorderless, ZeplinSearchResultIcon } from './icon';

export const zeplinConfig: ThirdPartyConfig = {
	displayName: 'Zeplin',
	id: 'zeplin',
	resourceType: ProductResourceTypes3P.Zeplin,
	icon: get3PLogo(ZeplinIcon, 'Zeplin', 'medium'),
	iconBorderless: get3PLogo(ZeplinIconBorderless, 'Zeplin', 'small'),
	searchResultIcon: get3PLogo(ZeplinSearchResultIcon, 'Zeplin', 'large'),
	integrationAri: 'ari:cloud:platform::integration/zeplin',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Design,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.Design],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
